import DebtFreeTimeHelper from '~/helpers/date-time';

export default {
    filters: {
        formatDebtFreeDate(value) {
            const date = new Date();
            const month = date.toString().split(' ')[1];
            return value <= 7500
                ? DebtFreeTimeHelper.getMonthYear(date, month, 12)
                : value > 7500 && value <= 10000
                    ? DebtFreeTimeHelper.getMonthYear(date, month, 24)
                    : DebtFreeTimeHelper.getMonthYear(date, month, 48);
        },
    },
};
